/**
 * VH-285 — what the server's refusals past the password step mean.
 *
 * Copied from FinanceHub `services/authErrors.js` (FH-104). The one module
 * that reads the `code` of an answer from the code step, the set-up and the
 * "just confirmed" gate; every screen asks here and shows a text of its own.
 *
 * The contract: those refusals are `{ detail: { code, message } }`, and the
 * `code` is what counts. A refusal without one (the gate's plain 401) means
 * the session is no longer good.
 */
export const AUTH_ERROR = {
  NETWORK: 'network',
  WRONG_CODE: 'wrongCode',
  CODE_USED: 'codeUsed',
  SETUP_CODE_WRONG: 'setupCodeWrong',
  SETUP_CODE_USED: 'setupCodeUsed',
  SETUP_CODE_EXPIRED: 'setupCodeExpired',
  HELD: 'held',
  TICKET_EXPIRED: 'ticketExpired',
  CONFIRMATION_REQUIRED: 'confirmationRequired',
  NOT_AUTHENTICATED: 'notAuthenticated',
  NO_SETUP: 'noSetup',
  // VH-296: passkeys.
  PASSKEY_REFUSED: 'passkeyRefused',
  NO_PASSKEY: 'noPasskey',
  PASSKEY_LIMIT: 'passkeyLimit',
  AUTHENTICATOR_FIRST: 'authenticatorFirst',
  PASSKEYS_UNAVAILABLE: 'passkeysUnavailable',
  OTHER: 'other',
}

const BY_CODE = {
  ticket_expired: AUTH_ERROR.TICKET_EXPIRED,
  invalid_code: AUTH_ERROR.WRONG_CODE,
  code_already_used: AUTH_ERROR.CODE_USED,
  setup_code_invalid: AUTH_ERROR.SETUP_CODE_WRONG,
  setup_code_used: AUTH_ERROR.SETUP_CODE_USED,
  setup_code_expired: AUTH_ERROR.SETUP_CODE_EXPIRED,
  confirmation_required: AUTH_ERROR.CONFIRMATION_REQUIRED,
  no_setup_in_progress: AUTH_ERROR.NO_SETUP,
  held: AUTH_ERROR.HELD,
  passkey_not_accepted: AUTH_ERROR.PASSKEY_REFUSED,
  no_passkey: AUTH_ERROR.NO_PASSKEY,
  passkey_limit: AUTH_ERROR.PASSKEY_LIMIT,
  authenticator_first: AUTH_ERROR.AUTHENTICATOR_FIRST,
  passkeys_unavailable: AUTH_ERROR.PASSKEYS_UNAVAILABLE,
}

const detailOf = (response) => {
  const detail = response.data?.detail
  return detail && typeof detail === 'object' && !Array.isArray(detail) ? detail : {}
}

/** → { kind, status } */
export function readAuthError(error) {
  const response = error?.response
  if (!response) return { kind: AUTH_ERROR.NETWORK, status: null }
  const { status } = response
  let kind = BY_CODE[detailOf(response).code]
  if (!kind) {
    if (status === 401) kind = AUTH_ERROR.NOT_AUTHENTICATED
    else if (status === 429) kind = AUTH_ERROR.HELD
    else kind = AUTH_ERROR.OTHER
  }
  return { kind, status }
}

export const isConfirmationRequired = (error) =>
  readAuthError(error).kind === AUTH_ERROR.CONFIRMATION_REQUIRED

/** The login in progress is over: its ticket ran out or is not accepted. */
export const isLoginOver = (error) =>
  [AUTH_ERROR.TICKET_EXPIRED, AUTH_ERROR.NOT_AUTHENTICATED].includes(readAuthError(error).kind)
